export const CONSTANT = {
  MICRO_SERVICE_ASSET_PREFIX: process.env.VUE_APP_ASSETS_MEDIA_MICRO_SERVICE_PREFIX,
  ASSET_PREFIX: process.env.VUE_APP_ASSETS_PREFIX,
  TOAST_STATE: {
    DANGER: 'danger',
  },

  SIZES: {
    EXTRA_SMALL: 'xs',
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl',
    FULL: 'full',
  },

  POSITION: {
    LEFT: 'left',
    RIGHT: 'right',
  },

  GROUP_REQUEST_STATUS: {
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
  },

  CHALLENGE_REQUEST_STATUS: {
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
  },

  TIMEZONE_SOURCE: {
    SIGNUP: 'signup',
    PROFILE_UPDATE: 'profile_update',
    AUTO_DETECTED: 'auto_detected',
  },

  VARIANTS: {
    PRIMARY: 'primary',
    YELLOW: 'yellow',
    BROWN: 'brown',
    BLACK: 'black',
    SECONDARY: 'secondary',
    DEFAULT: 'default',
    SECONDARY_BORDER: 'secondary-border',
    TERTIARY: 'tertiary',
  },

  STYLES: {
    ROUND: 'round',
    SQUARE: 'square',
  },

  GAMIFICATION_TYPES: {
    PREVIOUS: 'PREVIOUS',
    CURRENT: 'CURRENT',
    UPCOMING: 'UPCOMING',
  },

  GET_IMAGE_URL(img) {
    return img && img.includes('media-micro-service') ? `${this.MICRO_SERVICE_ASSET_PREFIX}${img}` : `${this.ASSET_PREFIX}${img}`
  },

  GET_DUMMY_IMAGE(size = '', text = '') {
    const imageSize = size || '300x250'
    const imageText = text || 'COREDIRECTION'
    const color = document.documentElement.style.getPropertyValue('--primary-default').replace('#', '')

    return `https://placehold.co/${imageSize}/${color}/white?font=montserrat&text=${imageText}`
  },

  MAKE_TOAST(bvToast, msg, title, variant) {
    if (!bvToast || typeof bvToast.toast !== 'function') {
      return
    }
    // Validation errors arrive as an array of messages; rendered as-is they
    // run together with no space between them.
    const text = Array.isArray(msg) ? msg.join(', ') : msg
    bvToast.toast(text, { title, autoHideDelay: 5000, variant, appendToast: true })
  },

  getUTMParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign')
    };
  },
  
  storeUTMParams() {
    const utmParams = this.getUTMParams();
    if (utmParams.utm_source) {
      sessionStorage.setItem('utm_params', JSON.stringify(utmParams));
    }
  },

  storedUTMParams(){
    if(sessionStorage.getItem('utm_params')){
      return JSON.parse(sessionStorage.getItem('utm_params'));
    }
  }
}
